import styled, { css } from 'styled-components';

export const Container = styled.footer`
	padding: 20px 30px;
	/* background-color: #fff; */
	background-color: ${p=>p.theme.colors.bgFooter};
	margin-top: 20px;
	width: 100%;
	cursor: default;
	flex-grow:1;
	max-height: 30%;
	color: ${p=>p.theme.colors.fgFooter};
	border-top: 10px solid ${p=>p.theme.colors.fgPrimary};
	font-weight: 400;
`;

export const Item = styled.div`
	display: flex;
	flex-direction: column;

	h3 {
		color: ${p=>p.theme.colors.fgPrimary};
		font-weight: 600;
		font-size: 1rem;
		margin-bottom: 7px;
	}

	a {
		color: ${p=>p.theme.colors.fgFooter};
		border-bottom: 2px solid transparent;
		width: max-content;
		margin-bottom: 2px;
		transition: border-bottom 150ms ease-in-out;
		text-decoration: none;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 100%;

		&:hover {
			border-bottom: 2px solid ${p=>p.theme.colors.fgPrimary};
			transition: border-bottom 150ms ease-in-out;
		}
	}
`;

export const FollowUs = styled.div`
	margin-top: 15px;
	display: flex;
	justify-content: space-evenly;
	align-items: center;

	a {
		color: ${p=>p.theme.colors.fgFooter};
		transition: color 150ms ease-in-out;
		text-decoration: none;
		cursor: pointer;
		border: none !important;

		& + a {
			margin-left: 10px;
		}

		&:hover {
			transition: color 150ms ease-in-out;
			color: ${p=>p.theme.colors.fgPrimary};
		}
	}
`;

export const ImgLink = styled.a`
	margin-right: 10px;
	height: 35px;
	min-height: 25px;
	max-height: 35px;
	width: 150px;
	min-width: 100px;
	max-width: 150px;
	margin: 0 !important;
	overflow: hidden;

	${({ img: { src, size, position } }) => css`
		background-image: url(${src});
		background-repeat: no-repeat;
		background-position: ${position || 'center center'};
		background-size: ${size};
	`}
`;


export const Texto = styled.span`
	color: ${p=>p.theme.colors.fgFooter};
`;